import { InboundPackageData } from "@deliverr/inbound-client";
import { boxWeightsInvalid, dimensionsAreValid, isMaxDimensions } from "../../InboundValidationUtils";

export const validateBoxDimsAndWeights = (pkg: InboundPackageData) =>
  dimensionsAreValid(pkg) && !isMaxDimensions(pkg) && !boxWeightsInvalid([pkg]);
